export default __webpack_public_path__ + "static/media/icono_gestion_sociedades.bc1c5140.png";